/**
 * Pending Transfers Hook
 * @see Sprint 28 - US-28.6
 */

import { useQuery } from '@tanstack/react-query';
import { dashboardService } from '../services/dashboard.service';
import { dashboardKeys } from './useDashboardData';

export function usePendingTransfers() {
  return useQuery({
    queryKey: [...dashboardKeys.all, 'pendingTransfers'] as const,
    queryFn: () => dashboardService.getPendingTransfers(),
    staleTime: 2 * 60 * 1000,
    placeholderData: (prev) => prev,
  });
}
